import Vue from "vue";
import VueI18n from "vue-i18n";
import vConsole from "vconsole";
import { ingame, dataURLtoFile, getSys, download, isMobile } from '@tencent/pa-cms-utils';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, saveRoleInfo, RoleInfo, getLoginedInitInfo, getMainVoteNums, submitBet, submitBetShare, submitMainShare, submitMainVote, getSpecialVoteNums, submitSpecialVote, getRewardRecord } from "@/api/modules/page";
import { IsTest, getLang, switchLang, isInIntlBrowser, getSpecialBrowserType, domToBase64, imageToBase64 } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, ProdServerMap, isHtm, game_id, htmUrl, MainStep, BetStep, SpecicalVoteStep, BetDays, VoteDays, MainStatus, ChooseNum } from "@/utils/const";
import { dynamicShare, share } from "@/utils/share";
import Login, { checkLogin } from "@/utils/login";
import './style.css'
import { setLanguageDialog, languageArr, closeLangDialog } from './utils/setLanguage'
import nikkes from './nikke.json'

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
const AegisIdMap = {
  "29157" : "zYWLZizDj7RG9d6aoR", 
  "29080": "dWmboSvoOJ09Wa7ZwW",
}
const AegisId = AegisIdMap[game_id];
if (!AegisId) {
  console.error("AegisId not found", game_id);
}
new Aegis({
  id: AegisId, // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
reportTlog({
  action: "year_half_home_page",
  sub_action: "cm_vshow"
});
(window as any).reportTlog = reportTlog;
const DEFAULT_LANG = "en";

const CMSLanguage = {
  en : 'en',
  th : 'th',
  fr : 'fr',
  de : 'de',
  pt : 'pt-all',
  es : 'es',
  id : 'id',
  ja : 'ja',
  ko : 'ko',
}
// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  }
}, {})
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
  // 静态Html 数据动态显示
  // document.title = i18n.t("title") as string;
  // const metas = document.getElementsByTagName("meta");
  // console.log('metas', metas)
  // const keywords = metas["keywords"];
  // const description = metas["description"];
  // if (keywords) {
  //   keywords.setAttribute("content", i18n.t("page.298"));
  // }
  // if (description) {
  //   description.setAttribute("content", i18n.t("page.299"));
  // }
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);
const languageMap = {
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  zh: 'tw',
};

const Lang = languageMap[urlLangType as keyof typeof languageMap];

(window as any).language = Lang?.toUpperCase();
(window as any).lanObjet = (window as any).GLanguage[(window as any).language];
(window as any).lanList = {'EN':"en",'TW':"tw",'TH':"th",'JA':"ja",'KO':"ko"};

const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// https://1024tools.com/timestamp utc+9
const startTimestamp = 1712501940; // 2024-04-07 23:59:00
const endTimestap= 1713193140; // 2024-04-15 23:59:00
// TODO test
// const startTimestamp= 1710860340; // 2024-03-19 23:59:00
// const endTimestap= 1713193140; // 2024-04-15 23:59:00

const dynamicPath = '20240407';
const nikkesJson = function() {
  const map = new Map();
  for(let nikke of nikkes) {
    const { company = ""} = nikke;
    const companyStrings =  company.split(' ');
    let short = '';
    if (companyStrings.length > 0) {
      short = companyStrings[0].toLocaleLowerCase();
    }
    map.set(nikke.id, { ...nikke, id:Number(nikke.id), company: short });
  }
  return Object.fromEntries(map.entries())
}()


new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,

      roleId: 0,
      areaId: 0,

      savedRoleId: 0,
      savedAreaId: 0,

      roleList: [],
      isLogin: checkLogin(),
      choosed: false,
      serverList: ProdServerMap,
      loading: false,
      
      isInIntlBrowser,
      isHtm,

      showMask: false,

      shareImgs: [],
      isInit: false, // 是否初始化， 只有在发送请求前才会触发登录

      betList: [], //竞猜记录
      currentMainVote: undefined, //当前主投票记录
      currentSpecialVote: undefined,// 当前特殊投票记录

      mainVotesNumbers: undefined,

      dayDiff: 0, // 活动开启天数
    }
  },
  computed: {
    languageText(){
      const lang = languageArr.find(lang =>lang.value === this.language)
      if (!lang) {
        const english = languageArr.find(lang =>lang.value === 'en')
        return english?.label
      }
      return lang.label;
    },
    roleName() {
      if (!this.isLogin) return ' ';
      if (!this.savedRoleId || !this.choosed) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.savedRoleId);
      if (!role) return '';
      return role.role_name;
    },
    selectRoleName() {
      if (!this.isLogin) return ' ';
      if (!this.roleId || !this.choosed) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    serverName() {
      if (!this.areaId) return this.$t('please_select');
      const server = this.serverList.find((server: any) => server.id == this.areaId);
      if (!server) return this.$t('please_select');
      return server.name;
    },
    showNv() {
      if (this.language === 'ko') return 'naver';
      if (isHtm || this.language === 'th') return 'facebook';
      return 'twitter';
    },
    showKakao() {
      const browser = getSpecialBrowserType();
      return !isInIntlBrowser && !['facebook', 'twitter'].includes(browser)
    },
    showLine() {
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'ios') return false;
      const browser = getSpecialBrowserType();
      if (!isInIntlBrowser && ['kakao'].includes(browser) && getSys().name?.toLowerCase() === 'android') return false;
      return true
    },
    showFacebook() {
      const browser = getSpecialBrowserType();
      if (!isInIntlBrowser && ['kakao'].includes(browser) && getSys().name?.toLowerCase() === 'android') return false;
      return true;
    },
    // 活动阶段
    step() {
      const dayDiff = this.dayDiff;
      let mainstep = MainStep.Bet;
      let specicalVoteStep = SpecicalVoteStep.UnStart;
      if (dayDiff >= BetDays && dayDiff < BetDays + VoteDays) {
        mainstep = MainStep.Vote;
        specicalVoteStep = dayDiff - BetDays;
      }
      if (dayDiff >= BetDays + VoteDays) {
        mainstep = MainStep.Finished;
        specicalVoteStep = SpecicalVoteStep.Finished;
      }
      // 主流程阶段  特殊投票阶段
      return { mainstep, specicalVoteStep };
    },
    // 是否竞猜
    betStep() {
      if (!this.betList || this.betList.length < 1) return BetStep.UnBet;
      return BetStep.Betted;
    },
    // 配合重构代码的状态 
    // 阶段 1：投票开始前，竞猜第一天  2： 投票开启中，著投票流程，第一天 
    // 3 ： 投票开启中第2~4天 4 ： 投票开启中第5~7天 5 ： 投票开启中，最终结果确认 
    status() {
      const { mainstep, specicalVoteStep} =  this.step;
      if (mainstep === MainStep.Bet) return MainStatus.Bet;
      if (mainstep === MainStep.Vote 
        && specicalVoteStep === SpecicalVoteStep.UnStart) return MainStatus.FirstVote;
      if (mainstep === MainStep.Vote && specicalVoteStep <= SpecicalVoteStep.Three) return MainStatus.SecondVote;
      if (mainstep === MainStep.Vote) return MainStatus.FiveVote;
      if (mainstep === MainStep.Finished) return MainStatus.Finished;
      return MainStatus.Bet;
    },
    betAndVoteData(){
      return {
        currentMainVote: this.currentMainVote, //当前主投票记录
        betList: this.betList,// 当前特殊投票记录
        mainVotesNumbers: this.mainVotesNumbers, // 所有主投票记录
      }
    },
    nikkeList() {
      // nikke数据列表
      if (!this.betAndVoteData.mainVotesNumbers) return [];
      /**
       * {
          id:0,
          name:'RAPI',
          voteNum:1243560,
          imgsele:'./ossweb-img/nikke_sele_img1.png',
          type:1,
          rank:1,
          userVoteNum: 0,
        },
       */
      // 3 ： 投票开启中第2~4天 按投票数排序 
      if (this.status ===  MainStatus.SecondVote) {
        const data = this.betAndVoteData.mainVotesNumbers.map((item: any, index: number)=> {
          const { vote_id: id, vote_num } = item;
          const nikke = nikkesJson[id];
          const name = nikke[this.language as keyof typeof nikke];
          const userVoteNum  = this.currentMainVote.filter((item: number) => item === id).length
          return {
            name,
            id: id,
            uin: id,
            voteNum: vote_num,
            // 竞猜阶段是竞猜数据，投票阶段是主投票数据
            userVoteNum,
            type: 1,
            rank: index + 1,
            // TODO 确定图片路径
            imgsele: `ossweb-img/role/${encodeURI(nikke.en).replace(":", '')}.png`,
            company: nikke.company,
          }
        });
       return data;
      }
      // 按文档中顺序排列
      const data = nikkes.map((item: any, index: number)=> {
        const { id } = item;
        const name = item[this.language as keyof typeof item];
        const userVoteNum = this.currentMainVote.filter((item: number) => item == id).length;
        return {
          name,
          id: id,
          uin: id,
          voteNum: 0,
          userVoteNum,
          type: 1,
          rank: ChooseNum + 1,
          // TODO 确定图片路径
          imgsele: `ossweb-img/role/${encodeURI(item.en).replace(":", '')}.png`,
          company: item.company,
        }
      });
      return data;
    },
    betNikkes() {
      if (!this.betAndVoteData.mainVotesNumbers || !this.betAndVoteData.betList) return [];
      // 按照票数排列
      const result = [];
      for (let index = 0; index < this.betAndVoteData.betList.length;  index++ ){
        const id = this.betAndVoteData.betList[index];
        const nikke = nikkesJson[id];
        const name = nikke[this.language as keyof typeof nikke];
        const userVoteNum = this.betList.filter((item: number) => item === id).length; 

        result.push({
          name,
          id: id,
          uin: id,
          voteNum: 0,
          // 竞猜阶段是竞猜数据，投票阶段是主投票数据
          userVoteNum,
          type: 1,
          rank: index + 1,
          // TODO 确定图片路径
          imgsele: `ossweb-img/role/${encodeURI(nikke.en).replace(":", '')}.png`,
          company: nikke.company,
        });
      }
      return result;
    },
    voteNikkes() {
      if (!this.betAndVoteData.mainVotesNumbers || !this.betAndVoteData.currentMainVote) return [];
      // 按照票数排列
      const result = new Map();
      for (let index = 0; index < this.betAndVoteData.currentMainVote.length;  index++ ){
        const id = this.betAndVoteData.currentMainVote[index];
        const nikkeInfo = result.get(id);
        if (nikkeInfo) {
          nikkeInfo.userVoteNum += 1;
          continue
        }
        const rank = this.betAndVoteData.mainVotesNumbers.findIndex((vote: any) => vote.vote_id == id);
        const nikke = nikkesJson[id];
        const name = nikke[this.language as keyof typeof nikke];
        result.set(id, {
          name,
          id: id,
          uin: id,
          voteNum: undefined,
          // 竞猜阶段是竞猜数据，投票阶段是主投票数据
          userVoteNum: 1,
          type: 1,
          rank: rank + 1,
          // TODO 确定图片路径
          imgsele: `ossweb-img/role/${encodeURI(nikke.en).replace(":", '')}.png`,
          company: nikke.company,
        });
      }
      return Array.from(result.values());
    },
    top5Nikkes() {
      // 只有主投票2~4天 显示top5
      if (this.status !== MainStatus.SecondVote) return []
      if (!this.betAndVoteData.mainVotesNumbers || this.betAndVoteData.mainVotesNumbers.length < 1) return [];
      // 按照票数排列
      const result = [];
      for (let index = 0; index < ChooseNum;  index++ ){
        const { vote_id: id, vote_num } = this.betAndVoteData.mainVotesNumbers[index];
        const nikke = nikkesJson[id];
        const name = nikke[this.language as keyof typeof nikke];
        result.push({
          name,
          id: index,
          uin: id,
          voteNum: vote_num,
          // 竞猜阶段是竞猜数据，投票阶段是主投票数据
          userVoteNum: 0,
          type: 1,
          rank: index + 1,
          // TODO 确定图片路径
          imgsele: `ossweb-img/role/${encodeURI(nikke.en).replace(":", '')}.png`,
          company: nikke.company,
        });
      }
      return result;
    }
  },
  watch: {
    language: {
     handler(val) {
        window.setLocal(val);
        const divs = languageArr.map(lang => {
          const divDom = window.$(`
            <li data="${lang.value}" class="${lang.value === val ? 'light' : ''}">${lang.label}</a>
          `);
          divDom.on('click', this.setLanguage)
          return divDom;
        })
        window.$('.top_language .top_lang_list').empty().append(divs)
        const langData = languageArr.find((langInfo) => langInfo.value === val);
        window.$('.top_language p').html(langData?.label);
      },
      immediate: true,
    },
    areaId(val) {
      if (!val || val === '0' || !checkLogin()) {
        this.buildRoleSelect([]);
        return;
      };
      const roles = this.roleList.filter((role: RoleInfo) => role.area_id === val);
      if (roles.length > 0) {
        this.roleId = roles[0].role_id;
        this.buildRoleSelect(roles);
        return;
      }
      this.loading = true;
      this.buildRoleSelect([]);
      this.roleId = '0'
      getRoleInfo({area_id: val }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.role_list) return;
        const { role_list: get_role_info = [] } = data;
        this.areaRoleMap.set(val, true);
        this.roleList.push(...get_role_info);
        // 异步 可能 areaId已改变
        if (val !== this.areaId) {
          return
        }
        if (get_role_info.length) {
          this.roleId = get_role_info[0].role_id;
        }
        this.loading = false;
        this.buildRoleSelect(get_role_info);
      }).finally(() => {
        this.loading = false;
      })
    },
    roleName: {
      handler(val) {
        if (!this.isLogin) {
          window.$(".top_user_hd").show();
          window.$(".top_user_name").hide();
          return;
        }
        if (!val || !this.choosed) {
          window.$(".top_user_hd").show();
          window.$(".top_user_name").hide();
          return;
        };
        window.$(".top_user_name").text(val);
        window.$(".top_user_name").show();
        window.$(".top_user_hd").hide();
      },
     immediate: true,
    },
    showMask: {
      handler(val) {
        const mask = window.$(".livingLoading");
        if (!val) {
          if (!mask.length) return;
          mask.addClass('unshow')
          return;
        }
        if (mask.length) {
          mask.removeClass('unshow');
          return;
        }
        const maskDom = window.$('<div class="livingLoading"></div>');
        maskDom.on("click", this.clcikMask)
        maskDom.appendTo(window.$("body"))
      },
      immediate: true,
    },
    betAndVoteData(val, oldVal) {
      // 数据全部返回才开始初始化
      const isValid = Object.keys(val).filter(key => val[key] !== undefined);
      if (isValid.length < 3) return;
      // 初始化数据返回后 修改状态
      const { currentMainVote, betList } = val;
      const main = (window as any).main;
      main.isfirst = betList.length > 0;
      main.isguess = betList.length > 0;
      main.isvote = currentMainVote.length > 0;
      main.isspevote = false;
      main.tabchange = this.step.specicalVoteStep;
      main.status = this.status;

      // TODO 不同状态 值不同
      if (this.status === MainStatus.FirstVote) {
        (window as any).userChooseDefault = this.betNikkes;
      } else if (this.status === MainStatus.SecondVote) {
        (window as any).userChooseDefault = this.top5Nikkes
      } else {
        (window as any).userChooseDefault = [];
      }
      if (this.status === MainStatus.Bet) {
        (window as any).userChoose = this.betNikkes;
      } else {
        (window as any).userChoose = this.voteNikkes;
      }
      (window as any).nikkeList = this.nikkeList;
      if (this.status === MainStatus.Bet) {
        (window as any).userVoteNum = ChooseNum;
      }else {
        (window as any).userVoteNum = ChooseNum - currentMainVote.length;
      }
      main.initPage();
      main.initSlice();
      // main.wallfull('p2_nikke','p2_swipbox','p2_swipscroll');
      main.renderNikke('p2_nikke', this.nikkeList, 1);
      main.setScrollBar('p2_swipbox', 'p2_swipscroll');
      main.renderChoose();
      if (this.status === MainStatus.SecondVote) {
        main.renderHomePage(1);
      }
      if ([MainStatus.FirstVote, MainStatus.SecondVote, MainStatus.FiveVote].includes(this.status)){
        const userChoose = (window as any).userChoose || [];
        let vote = 0;
        userChoose.forEach((choose: any) => {
          vote += choose.userVoteNum;
        })
        window.$('.userChooseNum').html(`${vote}/5`);
      }
      if (this.status === MainStatus.FiveVote && this.step.specicalVoteStep !== SpecicalVoteStep.Finished) {
        window.$('.p1voteb2').removeClass('no_guess');
      }
      if (this.status === MainStatus.FirstVote) {
        window.$('.p1voteb2').addClass('no_guess');
      }
      if (this.step.specicalVoteStep <= SpecicalVoteStep.UnStart) {
        window.$('#spefssure').addClass('grey')
      }
      if (this.step.specicalVoteStep === SpecicalVoteStep.Finished 
        || this.step.specicalVoteStep == SpecicalVoteStep.UnStart){
        window.$('.p2_tabbox ').hide()
      }
    },
   
  },
  async created(){
    (window as any).checkLogin = this.checkLogin;
    (window as any).main = new (window as any).Main();
    // TODO 去除指令
    (window as any).setDay = (day: string) =>{
      localStorage.setItem('dayDiff', day);
      window.location.reload();
    } 
    const search = new URLSearchParams(location.search);
    const day = search.get('day');
    if (IsTest) {
      if (day) {
        this.dayDiff = Number(day) - 1;
      } else {
        const dayDiff = localStorage.getItem('dayDiff');
        console.log('localStorage dayDiff', dayDiff);
        this.dayDiff = Number(dayDiff) - 1;
      }
    } else {
      const current = Date.now();
      const diff = current - startTimestamp * 1000;
      const dayDiff = Math.floor(diff / (24* 60 * 60 * 1000));
      this.dayDiff = dayDiff;
    }
    
    this.areaRoleMap = new Map();
    await Login.init()
    this.isLogin = checkLogin()
    await initServetime();

    await this.init();
    // this.addMask();

    // computed step
  },
  mounted(){
    // action
    window.$('.top_user_hd').on('click', this.clickLogin);
    window.$('.top_user_name').on('click', (event: Event) => {
      if (isInIntlBrowser) return;
      window.$('.top_dl_change').toggle();
      event.stopPropagation();
    });
    window.$(".top_dl_change .qh").on("click", this.trigerAreaSelect);
    window.$(".top_dl_change a:nth-child(2)").on("click", this.logout);
    window.$("#d3 .dia_surebtn").on("click", this.submitRole);
    // window.$('#p1').on('click', this.clickStart)
    // window.$('.p2_sure_btn').on('click', this.clickChoose)
    // window.$('.p5_share_btn').on('click', this.clickPrepareShare)
    // window.$(`.top_twitter_logo`).on('click', this.getOpenTwitterLink)

    this.appendShareChannel();

    window.$(".share_dia_close").on("click", () => window.$('.sharebtn4').show());

    // add report
    window.$(".p1_float_btn").on("click", () => {
      reportTlog({
        action: "year_half_vote_popularity_hall_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      })
    });
    window.$(".p1_rew_btn").on("click", () => {
      reportTlog({
        action: "year_half_vote_gift_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      })
    });
    window.$(".p1voteb3").on("click", () => {
      reportTlog({
        action: "year_half_vote_last_result_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      })
    });
  },
  methods: {
    resetMain() {
      const main = (window as any).main;
      main.isfirst = false;
      main.isguess = false;
      main.isvote = false;
      main.isspevote = false;
      main.tabchange = 1;
      main.status = this.status;

      // TODO 不同状态 值不同
      (window as any).userChooseDefault = [];
      (window as any).userChoose = [];

      (window as any).nikkeList = this.nikkeList;
      (window as any).userVoteNum = ChooseNum;
      main.status = this.status;
    },
    initMain() {
      const main = (window as any).main;
      main.init();

      if (!this.login || !this.choose) {
        window.$('.page1').removeClass('status2');
      }
      // 清除 点击提交角色 关闭弹窗
      const clickFuncs = this.getDomHandle(".dia_surebtn", "click");
      if (clickFuncs.length > 0) {
        const func = clickFuncs[0]?.handler;
        if (func) {
          window.$("#d3 .dia_surebtn").off("click", func);
        }
      }
      // 重写事件方法
      this.resetDomClickFun();
    },
    async init() {
      this.resetMain()
      this.getLoginedInitInfo();
      this.initMain();
    },
    // 活动过期蒙层
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessage(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessage(text: string) {
      window.showTips(text);
    },
    setLanguageDialog,
    setLanguage(event: Event) {
      event.stopPropagation();
      const dom = window.$(event.target)
      const lang = dom.attr("data");
      this.language = lang;
      closeLangDialog()
      // 切换语言跳链接
      switchLang(lang);
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (!this.roleId || this.roleId === '0' || !this.areaId || this.areaId === '0') {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (this.roleId === this.savedRoleId) {
        window.$('.dia').hide();
        return;
      }
      this.loading = true;
      try {
        const res = await saveRoleInfo({
          area_id: this.areaId,
          role_id: this.roleId,
        });
        if (res && res.code == 0) {
          // 切换角色
          this.choosed = true;
          // this.getLoginedInitInfo();
          this.savedAreaId = this.areaId;
          this.savedRoleId = this.roleId;
          window.$('.dia').hide();
        }
      } finally {
        this.loading = false;
      }
    },
    async trigerAreaSelect(){
      // this.areaId = `${this.serverList[0].id}`;
      this.areaId = `${this.savedAreaId || 0}`;
      this.buildServerSelect();
      this.changePage("d3");
    },
    buildServerSelect() {
      const divs = ProdServerMap.map(item => {
        const divDom = window.$(`<li value=${item.id} class="${item.id === this.areaId ? 'light' : ''}">${item.name}</li>`);
        divDom.on('click', this.handleSeverSelect)
        return divDom;
      })
      window.$('.dia_serve_list').empty().append(divs);
      const serverInfo = ProdServerMap.find((item) => item.id.toString() === this.areaId);
      const serverName = serverInfo?.name
      const lang = (window as any).GLanguage[(window as any).language]
      window.$('.dia_fw_name').empty().text(serverName || lang.lang163);
    },
    handleSeverSelect (event: Event){
      const value = window.$(event.target).val();
      this.areaId = `${value}`;
    },
    buildRoleSelect(roleList: RoleInfo[]) {
      let text = "";
      if (this.loading) {
        text = this.$t('loading');
      } else {
        text = roleList.map((role: RoleInfo) => {
          return role.role_name
        }).join('');
      }

      if (!text) {
        text = this.$t('NoRoleInfo');
      }
      
      window.$('.dia_fw_username span').text(text);
    },
    handleRoleSelect (event: Event){
      const value = window.$(event.target).children('option:selected').val();
      this.roleId = value;
    },
    async clickLogin(ev: any){
      if (!this.isLogin){
        this.checkLogin();
        return;
      }
      if (!this.choosed) {
        window.$('.top_dl_change').toggle();
        ev.stopPropagation();
      }
    },
    logout() {
      if (isInIntlBrowser) return;
      Login.logout();
      window.location.reload()
    },
    checkLogin() {
      if (!this.isLogin){
        // 打开登录框
        Login.login(this.language).then(async res => {
          if (res && (res.ret as any) === 0) {
            this.isLogin = true;
            await this.getLoginedInitInfo();
          }
        });
        return false;
      }
      if (!this.choosed) {
        this.trigerAreaSelect()
        return false;
      }
      return this.isLogin && this.choosed;
    },
    async getLoginedInitInfo() {
      // if (!this.isLogin) return;
      try {
        this.loading = true;
        window.$('.loading').show();
        await this.getLoginedInfo();
        if (this.status === MainStatus.SecondVote) {
          await this.getMainVoteNums();
        } else {
          this.mainVotesNumbers = [];
        }
        if (this.isLogin && !this.choosed) {
          this.trigerAreaSelect()
        }
      } finally {
        this.loading = false;
        window.$('.loading').hide();
      }
    },
    clickLogout(event: Event){
      event.stopPropagation();
      window.$('.loginout_box').show();
    },
    async dynamicShare(shareImg: string, channel = ''){
      if (this.isLoading) {
        return;
      }
      // (window as any).gm.loading()
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      this.isLoading = true;
      this.dynamicShareResult = null;
      this.downLoadImag = null;

      // 正常竞猜、主投票
      let userChoose = (window as any).userChoose.map((user: any) => user.uin).join('-');
      // 我的竞猜
      if (this.status !== MainStatus.Bet && this.shareType === MainStep.Bet) {
        userChoose = this.betList.join('-');
      // 特殊投票
      } else if (![MainStep.Bet, MainStep.Vote].includes(this.shareType)) {
        userChoose = (window as any).userSpeChoose;
      }
      // 临时使用时间戳作为uid, 上线后删除
      let uid = `${this.language}_${this.areaId}_${this.roleId}_${this.shareType}_${userChoose}_${dynamicPath}`;
      if (channel) {
        uid = `${uid}_${channel}`
      }
      console.log('uid', uid);
      this.downLoadImag = shareImg;
      // const shareImg2 = await this.getBase64Image('#certificateBox', { scale: 1 })
      // 港澳台 不使用分享服务， 无法部署资源， 修改html查看效果
      if (isHtm) {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖 TODO
          share_url: htmUrl,
        };
        this.isLoading = false;
        return
      };
      if (this.shareType === 'top') {
        this.dynamicShareResult = {
          // 港澳台分享地址， 由dynamicShareResult覆盖 TODO
          share_url: `${location.origin}${location.pathname}index.html?d=0409`,
        };
        this.isLoading = false;
        return
      }
      try {
        const cmsLang = CMSLanguage[this.language as keyof typeof CMSLanguage];
        const result = await dynamicShare({
          file: dataURLtoFile(shareImg, `${uid}.jpg`).file,
          uid,
          url_querys: new URLSearchParams({ language: cmsLang }),
        })
        this.dynamicShareResult = result;
        console.log('result', result)
      } catch (e){
        this.showMessage(this.$t("serverError"))
      } finally{
        this.isLoading = false;
      }
    },
    async dynamicSquareShare(){
      if (this.isLoading) {
        return;
      }
      try {
        window.$('.loading').show();
        const commonImg = await imageToBase64('./ossweb-img/share_kakao.jpg')
        await this.dynamicShare(commonImg, 'kakao');
      } finally {
        window.$('.loading').hide();
      }
    },
    async share(channel: string) {
      const action = this.shareType === 'top' ? 'year_half_vote_top_right_chanel_share_btn': 'year_half_vote_chanel_share_btn'
      reportTlog({
        action,
        sub_action: "cm_click",
        ext_content: {
          channel_name: channel,
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      })
      if (channel === 'kakao' && this.language !== 'zh' && this.shareType !== 'top') {
        await this.dynamicSquareShare();
      }
      if (this.isLoading || !this.dynamicShareResult) {
        this.showMessage(this.$t("laodingPic"))
        return;
      }

      // 竞猜和主投票才有奖励，需要告知后端
      const SubmitShareMap = {
        [MainStep.Bet]: submitBetShare,
        [MainStep.Vote]: submitMainShare,
        top: async () => ({ code: 0 }),
      }
      const submitShare = SubmitShareMap[this.shareType as keyof typeof SubmitShareMap] || submitMainShare;
      if (!!submitShare) {
        const res = await submitShare();
        if (!res || res.code !== 0) return;
      }
      const shareContentMap = {
        [MainStep.Bet]: 'shareContentBet',
        [MainStep.Vote]: 'shareContentVote',
        top: 'shareContentTop',
      }
      const shareContentKey =  shareContentMap[this.shareType as keyof typeof shareContentMap] || 'shareContentSpecial'
      // TODO 分享 文案
      const shareContent = this.$t(shareContentKey);
      try{
        await share({
          ...this.dynamicShareResult,
          app_id: fb_app_id,
          title: shareContent,
          text: shareContent,
          hashtag: "#votefornikke2024",
          channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
    },
    async getBase64Image(selector: string, options = { scale: 2 }){
      const dom = document.querySelector(selector) as HTMLElement;
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    async getBase64ImageByDom(dom: HTMLElement, options = { scale: 2 }){
      if (!dom) return;
      const uri = await domToBase64(dom, { ...options })
      return uri; // 获取生成的图片的url
    },
    downloadImage() {
      reportTlog({
        action: "year_half_vote_download_pic_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      })
      const browser = getSpecialBrowserType();
      // android 无法保存图片
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'android') {
        if (this.loading || !this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        // 【安卓】繁中 游戏内点击游戏下载按钮出现闪退
        // if (isHtm) {
          this.showMessage(this.$t("open_in_browser"));
        //   return
        // }
        // ingame.openInBrowser(this.downloadUrl || this.downLoadImag);
      } else if (['facebook', 'line', 'ins'].includes(browser) && getSys().name?.toLowerCase() === 'android') {
        // 提示
        this.showMessage(this.$t("open_in_browser"));
        return;
        // window.open(this.dynamicShareResult.image_url, '_blank');
      } else {
        if (!this.downLoadImag) {
          this.showMessage(this.$t('laodingPic'))
          return;
        }
        // 竞猜和主投票
        const nameKeyMap = {
          [MainStep.Bet]: 'lang127',
          [MainStep.Vote]: 'lang129',
          top: ' ',
        }
        const nameKey = nameKeyMap[this.shareType as keyof typeof nameKeyMap] || 'lang131';
        const lang = (window as any).GLanguage[(window as any).language]
        const title = lang['lang0'];
        const name = lang[nameKey];
        download({
          base64: this.downLoadImag,
          filename: `${title}${name ? '-' + name : ''}`,
        });
      }
    },
    async getLoginedInfo() {
      const res = await getLoginedInitInfo()
      if (!res || res.code !== 0) {
        this.betList = [];
        this.currentMainVote = [];
        return;
      }
      const { data } = res;
      const { get_saved_role_info, guess_list = [], vote_list = [] } = data;
      this.choosed = !!get_saved_role_info;
      this.betList = guess_list;
      this.currentMainVote = vote_list;
      if (get_saved_role_info) {
        const { area_id, role_id }  = get_saved_role_info || {};
        this.roleList = [get_saved_role_info];
        this.savedAreaId = area_id;
        this.savedRoleId = role_id;
        this.areaRoleMap.set(area_id, true);
      } else {
        this.roleList = [];
        this.savedAreaId = 0;
        this.savedRoleId = 0;
      }
    },
    getOpenTwitterLink(e: Event) {
      e.preventDefault();
      interface LinkMap {
        [key: string]: {
          pc: string;
          mobile: string;
        };
      }
      const linkMap: LinkMap = {
        ja: {
          pc: 'https://twitter.com/NIKKE_japan',
          mobile: 'https://twitter.com/NIKKE_japan',
        },
        ko: {
          pc: 'https://game.naver.com/lounge/NIKKE_The_Goddess_of_Victory/home',
          mobile: 'https://game.naver.com/lounge/NIKKE_The_Goddess_of_Victory/home',
        },
        en: {
          pc: 'https://twitter.com/NIKKE_en',
          mobile: 'https://twitter.com/NIKKE_en',
        },
        zh: {
          pc: 'https://www.facebook.com/TW.NIKKE',
          mobile: 'https://www.facebook.com/TW.NIKKE',
        },
        th: {
          pc: 'https://www.facebook.com/nikke.th.official',
          mobile: 'https://www.facebook.com/nikke.th.official',
        },
      }
      const link = linkMap[getLang()];
      if (!link) return window.open('https://twitter.com/NIKKE_en', '_blank');
      if (isMobile()) return window.open(link.mobile, '_blank');
      return window.open(link.pc, '_blank');
    },
    getOpenFacebookLink(e: Event) {
      e.preventDefault();
      return window.open('https://www.facebook.com/TW.NIKKE/', '_blank');
    },
    getOpenNarLink(e: Event){
      e.preventDefault();
      return window.open('https://game.naver.com/lounge/nikke/board/11/', '_blank');
    },
    toPolicy(type: 'cookie' | 'privacy' = 'cookie') {
      const map = {
        cookie: this.$t('cookiesLink'),
        privacy: this.$t('privacyLink'),
      };
      const url = map[type]
      window.open(url, '_blank');
    },
    longTouch(dom: any, callback: Function, duration = 1000){
      // TODO pc 判断长按
      let timeOutEvent = 0 // 用来设置定时器，且 0 数值用于后续判断
      dom.on('touchstart', function(e: Event) {
        // 阻止它的默认事件
        // e.preventDefault()
        // 当开始触摸的时候定时器计时
        timeOutEvent = setTimeout(function() {
            timeOutEvent = 0
            console.log('你长按了')
            callback()
        }, duration) // 达到 1s 就会实现长按效果
      })
      dom.on('touchmove', function(e: Event) {
        // 如果触摸未达到 1s 且开始移动，则清除计时器
        clearTimeout(timeOutEvent)
        timeOutEvent = 0
      })
      dom.on('touchend', function(e: Event) {
        // 如果触摸未达到 1s 且离开屏幕，则清除计时器
        clearTimeout(timeOutEvent)
        if (timeOutEvent !== 0) {
          // 判断是否发生长按
            console.log('你这是点击，不是长按')
        }
        // return false
      })
    },
    appendShareChannel() {
      const shareChannelMap = {
        en: ['twitter', 'facebook'],
        th: ['twitter', 'facebook', 'line'],
        ja: ['twitter', 'line'],
        ko: ['kakao','twitter'],
        zh: ['facebook', 'line','twitter'],
      };
      const shareChannel = shareChannelMap[this.language as keyof typeof shareChannelMap];
      const divs = shareChannel.map(channel => {
        if (channel === 'kakao' && !this.showKakao) return;
        if (channel === 'line' && !this.showLine) return;
        if (channel === 'facebook' && !this.showFacebook) return;

        const nameMap = {
          twitter: 'sharebtn3',
          facebook: 'sharebtn1',
          line: 'sharebtn2',
          kakao: 'sharebtn4'
        }
        const name = nameMap[channel as keyof typeof nameMap];
        const divDom = window.$(`<a href="javascript:;"  target="_blank" class="${name}" title=""></a>`);
        divDom.on('click', (e: Event) => {
          try {
            e.preventDefault();
            this.share(channel);
          } finally {
            return false;
          }
        })
        return divDom;
      })
      const download = window.$(`<a class="downloadbtn" title="" target="_blank"></a>`)
      download.on("click", () => {
        try {
          reportTlog({
            action: "year_half_vote_download_pic_btn",
            sub_action: "cm_click",
            ext_content: {
              areaid: this.savedAreaId,
              roleId: this.savedRoleId,
              type: this.shareType,
            }
          });
          this.downloadImage()
        } finally {
          return false;
        }
      });
      window.$('.share_dia .share_btnbox').empty().append(divs).append(download);
    },

    changePage(id: string) {
      (window as any).showDialog(id);
    },
    async getMainVoteNums() {
      const res = await getMainVoteNums()
      if (!res || res.code !== 0) return;
      const { data } = res;
      const { vote_list = [] } = data;
      this.mainVotesNumbers = Object.freeze(vote_list);
    },
    async submitBet() {
      reportTlog({
        action: "year_half_vote_bet_confirm_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      });
      const userChoose = (window as any).userChoose;
      if (!userChoose || userChoose.length < ChooseNum) return false;
      const guess_list: number[] = userChoose.map((item: { uin: number}) => item.uin);
      try {
        window.$('.loading').show();
        const res = await submitBet(guess_list);
        if (!res || res.code !== 0) return false;
        return true;
      } catch {
        return false
      } finally {
        window.$('.loading').hide();
      }
    },
    improveBetReset() {
      const main = window.main;
      main.isguess = this.betAndVoteData.betList.length > 0;
    },
    improveGuessClick(){
      // const userChoose = (window as any).userChoose;
      // if (!userChoose || userChoose.length < ChooseNum) return;
      // (window as any).main.renderMyChoose();
      this.shareType = MainStep.Bet;
      reportTlog({
        action: "year_half_vote_bet_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      });
      return true;
    },
    controlBetShare() {
      reportTlog({
        action: "year_half_vote_share_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      });
      // 修正 我的竞猜 数据占用 userChoose
      if (this.shareType === MainStatus.Bet && this.status !== MainStatus.Bet) {
        (window as any).userChoose = this.betNikkes;
      }
      return true;
    },
    improveBetShare(){
      const observer = new MutationObserver(async (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].nodeName === 'IMG') {
              try {
                window.$('.loading').show();
                const dom = window.$('.share_dia .share_imgbox_show').find('img')
                if (!dom) return false;
                const url = dom.attr('src') || '';
                if (!url) return false;
                await this.dynamicShare(url);
                observer.disconnect()
                return true;
              } finally {
                window.$('.loading').hide();
              }
            }
            if (mutation.removedNodes.length > 0 && mutation.removedNodes[0].nodeName === 'IMG') {
              observer.disconnect();
            }
          }
        }
      });
      
      const targetNode = document.querySelector('.share_dia'); // 监听整个body，你可以根据实际情况选择合适的目标元素
      const config = { childList: true, subtree: true };
      observer.observe(targetNode!, config);

      // 修正 我的竞猜 数据占用 userChoose
      if (this.shareType === MainStatus.Bet) {
        if (this.status === MainStatus.Bet) {
          (window as any).userChoose = this.betNikkes;
        } else {
          (window as any).userChoose = this.voteNikkes;
        }
      }
    },
    controlVoteReset() {
      reportTlog({
        action: "year_half_vote_reset_role_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      });
      const main = window.main;
      if (main.isvote) return false;
      return true;
    },
    improveVoteReset() {
      window.main.isguess = this.betAndVoteData.betList.length > 0;
      window.main.renderNikke('p2_vote_nikke',(window as any).userChoose,2);
      window.$('.vote_control_ipt').html(1)
    },
    controlVoteShareCancel() {
      return true;
    },
    improveVoteShareCancel() {
      const main = window.main;
      // main.isguess = this.betAndVoteData.betList.length > 0;
      main.renderNikke('p2_vote_nikke',(window as any).userChoose,2);
      // TODO shareType 判断 
      if (main.isguess && this.shareType === MainStatus.Bet && this.status !== MainStatus.Bet) {
        main.showPage('page1');
      }
    },
    async submitMainVote() {
      const userChoose = (window as any).userChoose || [];
      const vote_list: number[] = []
      userChoose.forEach((item: { uin: number; userVoteNum: number}) => {
        for (let i = 1; i <= item.userVoteNum; i++) {
          vote_list.push(item.uin)
        }
      });
      reportTlog({
        action: "year_half_vote_main_role_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          role_ids: vote_list,
        }
      });
      if (window.main.isvote) return false;
      if (!userChoose || userChoose.length <= 0) return true;
      let allVotes = 0;
      for(let user of userChoose) {
        allVotes += user.userVoteNum;
      }
      if (allVotes < ChooseNum) return true;
      try {
        window.$('.loading').show();
        const res = await submitMainVote(vote_list);
        if (!res || res.code !== 0) return false;
        reportTlog({
          action: "year_half_vote_main_role_success",
          sub_action: "cm_click",
          ext_content: {
            areaid: this.savedAreaId,
            roleId: this.savedRoleId,
            role_ids: vote_list,
          }
        });
        return true;
      } catch {
        return false
      }finally {
        window.$('.loading').hide();
      }
    },

    controlVotePlusorReduce() {
      const main = window.main;
      if (main.isvote) return false;
      return true;
    },
    improveVotePlusorReduce() {
      const userChoose = (window as any).userChoose || [];
      let result = 0;
      for(const choose of userChoose) {
        result += choose.userVoteNum || 0;
      }
      window.$('.userChooseNum').html(`${result}/5`);
    },
    controlNikkeClick() {
      const main = window.main;
      // 竞猜可以反复投递
      if (this.status === MainStatus.Bet && main.isguess) return true;
      if ([MainStatus.FirstVote, MainStatus.SecondVote, MainStatus.FiveVote].includes(this.status)
       && main.isvote) return false;
      return true
    },
    async controlGoSpecialVote() {
      if ([SpecicalVoteStep.UnStart, SpecicalVoteStep.Finished].includes(this.step.specicalVoteStep)){
        return false;
      }
      if (this.status === MainStatus.FirstVote) {
        // TODO 提示
        return false;
      }
      reportTlog({
        action: "year_half_vote_special_page",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      });
      try {
        window.$('.loading').show();
        const main = window.main;
        if (!this.specialVote) {
          const res = await getSpecialVoteNums(this.step.specicalVoteStep);
          if (!res || res.code !== 0) return false;
          const { vote_log_list = [] } = res.data;
          const tagId = vote_log_list.length ? vote_log_list[0].tag_id : '';
          this.specialVote = true;
          const type = main.specialNameList[main.tabchange - 1];
          (window as any).userSpeChoose = `${type}${tagId}`;
          main.isspevote = !!tagId;
        }
        main.initSpecial();
        main.showIsspevote();
        main.addSpecialLight();
        return true
      } catch {
        return false;
      } finally {
        window.$('.loading').hide();
      }
    },
    async controlVoteTypeChange(event: any) {
      const index = window.$('.p2_tabbox a').index(event.target);
      // TODO 渲染特殊投票
      if (index === 1) {
        return await this.controlGoSpecialVote();
      }
      return true;
    },
    async controlSpecialVote() {
      const userSpeChoose = (window as any).userSpeChoose;
      const regx = new RegExp(/[0-9]+/g);
      const numMatch = userSpeChoose.match(regx);
      const speChoose = numMatch?.length > 0 ? numMatch[0] : ''
      reportTlog({
        action: "controlSpecialVote",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          role_ids: userSpeChoose ? [userSpeChoose] : [],
        }
      });
      if ([SpecicalVoteStep.UnStart, SpecicalVoteStep.Finished].includes(this.step.specicalVoteStep)){
        return false;
      }
      if (!userSpeChoose || !speChoose) return false;
      try {
        window.$('.loading').show();
        const res = await submitSpecialVote(this.step.specicalVoteStep, Number(speChoose));
        if (!res || res.code !== 0) return false;
        reportTlog({
          action: "year_half_vote_specail_role_ret",
          sub_action: "cm_click",
          ext_content: {
            areaid: this.savedAreaId,
            roleId: this.savedRoleId,
            role_ids: userSpeChoose ? [userSpeChoose] : [],
            ret: res.code,
          }
        });
        return true;
      } catch {
        return false
      } finally {
        window.$('.loading').hide();
      }
    },
    controlSpecialVoteShare(){
      this.shareType = `${this.step.mainstep}-${this.step.specicalVoteStep}`;
      reportTlog({
        action: "year_half_vote_specail_share_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      });
      return true;
    },
    improveSpecialVoteShare(){
      const observer = new MutationObserver(async (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].nodeName === 'IMG') {
              try {
                window.$('.loading').show();
                const dom = window.$('.share_dia .share_imgbox_show').find('img')
                if (!dom) return false;
                const url = dom.attr('src') || '';
                if (!url) return false;
                await this.dynamicShare(url);
                observer.disconnect();
                return true;
              } catch(e) {
                console.log('e', e)
              } finally {
                window.$('.loading').hide();
              }
            }
            if (mutation.removedNodes.length > 0 && mutation.removedNodes[0].nodeName === 'IMG') {
              observer.disconnect();
              this.shareType = undefined;
            }
          }
        }
      });
      
      const targetNode = document.querySelector('.share_dia'); // 监听整个body，你可以根据实际情况选择合适的目标元素
      const config = { childList: true, subtree: true };
      observer.observe(targetNode!, config);
    },
    async improveSpecialShareCancel() {
      const main = window.main;
      main.showPage('page2');
      // TODO 底部按钮修改
    },

    controlMyBet() {
      // 上报
      reportTlog({
        action: "year_half_vote_my_prediction_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      })

      // 修正 我的竞猜 数据占用 userChoose
      if (this.status !== MainStatus.Bet) {
        (window as any).userChoose = this.betNikkes;
        (window as any).userChooseDefault = this.betNikkes;
      }
      return true;
    },
    improveMyBet() {
      this.shareType = MainStep.Bet;
      // 修正 我的竞猜 数据占用 userChoose
      if (this.status === MainStatus.Bet) {
        (window as any).userChoose = this.betNikkes;
        (window as any).userChooseDefault = this.betNikkes;
      } else {
        (window as any).userChoose = this.voteNikkes;
        (window as any).userChooseDefault = this.voteNikkes;
      }

      window.$('.p3_share_list').show();
      const main = window.main;
      if (main.isguess) {
        window.$('.p3_btnbox').show();
      } else {
        window.$('.p3_btnbox').hide();
      }
    },
    improveMyResult() {
      this.shareType = this.step.mainstep;
      // TODO
      window.$('.p3_share_list,.p3_btnbox').show();
      window.$('.p3_tp').show();
      window.$('.p3_isempty,#p3vote').hide();
      window.$('.p3_jc').hide();

      window.$('#p3reset').hide();
      window.$('#p3back').show();

    },
    improveMainVote() {
      this.shareType = MainStep.Vote;
    },
    controlVoteBtn() {
      reportTlog({
        action: "year_half_vote_now_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      })
      return true;
    },
    improveVoteBtn(){
      window.$('.p2_main_tp').show();
      window.$('.p2_main_spe').hide();
      window.$('.page2').removeClass('spebg');
      window.$('.p2_tabbox').find('a').eq(0).addClass('light').siblings().removeClass('light');
      reportTlog({
        action: "year_half_vote_home_page",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
        }
      })
    },
    controlSpecialVoteChoose() {
      const main = window.main;
      if (main.isspevote) return false;
      return true;
    },
    async controleShowReward() {
      try {
        window.$('.loading').show();
        const res = await getRewardRecord();
        if (!res || res.code !== 0) return false;
        const { user_gift_collection_record = {} } = res?.data;
        const rewardIndexMap = {
          1: 'guess_present',
          2: 'guess_share_present',
          3: 'vote_present',
          4: 'daily_vote_present',
          5: 'vote_share_present',
        };
        window.$('.dia_rew_list li').each(function(index: number, dom: any){
          const key = rewardIndexMap[(index + 1) as keyof typeof rewardIndexMap];
          const isActive= user_gift_collection_record[key as keyof typeof user_gift_collection_record];
          const rewardDom = window.$(dom);
          if (isActive) {
            rewardDom.addClass('ove');
            return;
          }
          rewardDom.removeClass('ove');
        })
        Object.keys(rewardIndexMap).forEach(idnex => {

        })
        return true;
      } catch {
        return false
      } finally {
        window.$('.loading').hide();
      }
    },
    controlTopShare(){
      this.shareType = 'top';
      reportTlog({
        action: "year_half_vote_top_right_share_btn",
        sub_action: "cm_click",
        ext_content: {
          areaid: this.savedAreaId,
          roleId: this.savedRoleId,
          type: this.shareType,
        }
      });
      return true;
    },
    improveTopShare(){
      const observer = new MutationObserver(async (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].nodeName === 'IMG') {
              try {
                window.$('.loading').show();
                const dom = window.$('.share_dia .share_imgbox_show').find('img')
                if (!dom) return false;
                const url = dom.attr('src') || '';
                if (!url) return false;
                await this.dynamicShare(url);
                observer.disconnect();
                return true;
              } catch(e) {
                console.log('e', e)
              } finally {
                window.$('.loading').hide();
              }
            }
            if (mutation.removedNodes.length > 0 && mutation.removedNodes[0].nodeName === 'IMG') {
              observer.disconnect();
              this.shareType = undefined;
            }
          }
        }
      });
      
      const targetNode = document.querySelector('.share_dia'); // 监听整个body，你可以根据实际情况选择合适的目标元素
      const config = { childList: true, subtree: true };
      observer.observe(targetNode!, config);
      window.$('.sharebtn4').hide();
    },
    resetDomClickFun() {
      this.restClickEvent('#guessbtn', 'click', 0, this.improveGuessClick);
      this.restClickEvent('#p2sure', 'click', 0, this.submitBet);
      this.restClickEvent('#p2reset', 'click', 0, () => true, this.improveBetReset);
      // 竞猜 和 主投票 分享
      this.restClickEvent('#p3share', 'click', 0, this.controlBetShare, this.improveBetShare);
      this.restClickEvent('.user_login', 'click', 0, () => false);
      // this.restClickEvent('.top_user_name', 'click', 0, () => !isInIntlBrowser);
      this.restClickEvent('#votebtn', 'click', 0, this.controlVoteBtn, this.improveVoteBtn);
      this.restClickEvent('#p2cztreset', 'click', 0, this.controlVoteReset, this.improveVoteReset);
      // 竞猜 和 主投票 分享页共用
      this.restClickEvent('#p3reset', 'click', 0, this.controlVoteShareCancel, this.improveVoteShareCancel);
      this.restClickEvent('#p3back','click', 0, () => true, this.improveVoteShareCancel)

      this.restClickEvent('#p2cztvote', 'click', 0, this.submitMainVote, this.improveMainVote);
      // .page2 a.vote_control_add
      this.restClickEvent('.page2', 'click', 0, this.controlVotePlusorReduce, this.improveVotePlusorReduce);
      // .page2 a.vote_control_red
      this.restClickEvent('.page2', 'click', 1, this.controlVotePlusorReduce, this.improveVotePlusorReduce);
      // .page2 a.vote_delet
      this.restClickEvent('.page2', 'click', 2, this.controlVotePlusorReduce, this.improveVotePlusorReduce);
      
      this.restClickEvent('.p2_swipbox', 'click', 0, this.controlNikkeClick, this.improveVotePlusorReduce);
      this.restClickEvent('.p2_tabbox', 'click', 0, this.controlVoteTypeChange);
      // 首页特殊投票入口
      this.restClickEvent('#votebtnspe', 'click', 0, this.controlGoSpecialVote);

      // 我的競猜
      this.restClickEvent('.p1_jc', 'click', 0, this.controlMyBet,this.improveMyBet);
      // 我的投票纪录
      this.restClickEvent('#p2cztmy', 'click', 0, undefined, this.improveMyResult);
      // 特殊投票选择
      this.restClickEvent('#spefssure', 'click', 0, this.controlSpecialVote);
      // 特殊投票
      this.restClickEvent('.tbfs', 'click', 0, this.controlSpecialVoteChoose);
      // 特殊投票 分享
      this.restClickEvent('#p4share', 'click', 0, this.controlSpecialVoteShare, this.improveSpecialVoteShare);
      //  特殊投票 分享取消
      this.restClickEvent('.p2_btnbox3 .p2_btn1', 'click', 0, () => true, this.improveSpecialShareCancel);

      this.restClickEvent('.p1_rew_btn', 'click', 1, this.controleShowReward);

      this.restClickEvent('.top_share', 'click', 0, this.controlTopShare, this.improveTopShare, false);
    },
    restClickEvent(selecter: string, eventName = 'click', index = 0,  preFunc = () => true, callback?: Function, needLogin = true) {
      const clickFuncs = this.getDomHandle(selecter, eventName);
      const clickFunc = clickFuncs[index]?.handler;
      if (!clickFunc) {
        console.error('dont have event handler', clickFuncs, index);
        return;
      }
      const _this = this;
      const func = async function(event: any){
        if (_this.loading) return;
        if (needLogin && !_this.checkLogin()) return;
        try {
          // @ts-ignore
          const result = await preFunc?.call(this, event, ...arguments);
          // 前置函数返回值 决定是否跳过 绑定事件方法
          if (!result) return;
          // @ts-ignore
          await clickFunc.call(this, event, ...arguments);
          // @ts-ignore
          await callback?.call(this, event, ...arguments);
        } catch (e){
          console.log('restClickEvent', e);
        }
       
      }
      clickFuncs[index].handler = func;
    },
    getDomHandle(selector: string,  eventName = 'click'){
      const clickEvent = (window.$ as any)._data(document.querySelector(selector), "events");
      if (!clickEvent) return [];
      const clickFuncs = clickEvent[eventName];
      return clickFuncs || [];
    } 
  },
});
